module.exports = __webpack_public_path__ + "media/images/athletes/507-187428f792f323d889882c0e7d9aef5c.png";